import { isSourceKeyFormat } from '@/utils/number';
import round from 'lodash-es/round';
import { getImageObject, getLayerRecolorEnabled, getRefName } from '../utils';
import { ShapeType } from '@/services/shape';

export function DataItemArcProgressBarLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    bg: getImageObject(resAst, getRefName(layerAst.attrsMap.bg), colors),
    progress: getImageObject(resAst, getRefName(layerAst.attrsMap.ref), colors),
    indicatorImage: getImageObject(
      resAst,
      getRefName(layerAst.attrsMap.indicatorImage),
      colors
    )
  };
  layer.attrs.recolorEnable = getLayerRecolorEnabled(
    resAst,
    getRefName(layerAst.attrsMap.ref)
  );
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
  layer.attrs.progressBarType = 'arc';
  layer.type = ShapeType.ProgressBar;

  const {
    angleStart = 0,
    angleRange = 0,
    valueStart = 0,
    valueRange = 0,
    barWidth = 0,
    // 圆弧中心位置对应的半径，即内环与外环半径的均值
    barRadius = 0
  } = layerAst.attrsMap;
  // 进度条角度
  layer.attrs.angleStart = Number(angleStart);
  layer.attrs.angleEnd = layer.attrs.angleStart + Number(angleRange);
  // 进度条最大最小值
  layer.attrs.valueStart = isSourceKeyFormat(valueStart)
    ? valueStart
    : Number(valueStart);
  layer.attrs.valueEnd = isSourceKeyFormat(valueRange)
    ? valueRange
    : Number(valueStart) + Number(valueRange);
  // 比例
  const _barRadius = Number(barRadius);
  const _barWidthHalf = Number(barWidth) / 2;
  layer.attrs.innerRingPercent = round(
    ((_barRadius - _barWidthHalf) / (_barRadius + _barWidthHalf)) * 100
  );
  layer.attrs.barRadius = _barRadius;
  layer.attrs.barWidth = _barWidthHalf * 2;
}
